// extracted by mini-css-extract-plugin
export var hideEditor = "_sc-2";
export var infoIcon = "_sc-3";
export var label = "_sc-1";
export var labelContainer = "_sc-0";
export var readonlyText = "_sc-4";